import Icon from '../../../components/AppIcon';

const TrustSignalsSection = () => {
  const certifications = [
    { name: 'ISO 27001', description: 'Безопасность данных' },
    { name: 'GDPR', description: 'Защита персональных данных' },
    { name: 'AI Ethics', description: 'Этичное использование AI' },
    { name: 'SSL', description: 'Шифрование данных' }
  ];

  return (
    <section className="py-20 bg-card border-y border-border">
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h3 className="text-2xl font-bold text-foreground mb-4">
            Ваша безопасность — наш приоритет
          </h3>
          <p className="text-secondary">
            Мы используем передовые технологии защиты данных и соблюдаем международные стандарты
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {certifications?.map((cert, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <Icon name="Shield" size={32} color="var(--color-primary)" />
              </div>
              <div className="font-semibold text-foreground mb-1">{cert?.name}</div>
              <div className="text-sm text-secondary">{cert?.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignalsSection;